import { devEnv } from './environment.dev';
import { qaEnv } from './environment.qa';
import { prodEnv } from './environment.prod';
import { localEnv } from './environment';
import { DesignToolsConfig } from '../config/config.schema';
import { prodTestEnv } from './environment.prodTest';

export const getConfig = (): DesignToolsConfig => {
  // get stage based pn the website
  // if our site have this url `https://3d-shop-dev.myshopify.com` for dev
  // if our site have this url `https://3d-shop-qa.myshopify.com` for qa
  // if our site have this url (https://expoprep.myshopify.com, https://expoprep.io, https://expoprep-prod.myshopify.com) for prod
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  let stage;
  if (origin.includes('.dev.truetale.io')) stage = 'dev';
  else if (origin.includes('.qa.truetale.io')) stage = 'qa';
  else if (origin.includes('expoprint-prod') || origin.includes('milo-print')) stage = 'prod-test';
  else if (
    origin.includes('expoprint.io') ||
    origin.includes('miloprint.com') ||
    origin.includes('vividtents.com') ||
    origin.includes('squadmojo.com')
  )
    stage = 'prod';

  switch (stage) {
    case 'dev':
      return devEnv;
    case 'qa':
      return qaEnv;
    case 'prod':
      return prodEnv;
    case 'prod-test':
      return prodTestEnv;
    default:
      return qaEnv;
  }
};
